import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=ad1f5fba&"
import script from "./Option.vue?vue&type=script&lang=js&"
export * from "./Option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad1f5fba')) {
      api.createRecord('ad1f5fba', component.options)
    } else {
      api.reload('ad1f5fba', component.options)
    }
    module.hot.accept("./Option.vue?vue&type=template&id=ad1f5fba&", function () {
      api.rerender('ad1f5fba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Sidepanel/Option.vue"
export default component.exports